import {Button, Modal, Spinner, Toast} from "react-bootstrap";
import React from 'react';

export default function PromptModal(props) {


    const handleOk = async () => {
        await props.handlePrompt()
    }

    return (
        <Modal dialogClassName="filter-modal" show={props.show} onHide={() => {
            props.setShow(false);
            if(props.setShowError) {
                props.setShowError(false);
            }
        }} style={{marginTop: '10%', left: '1%'}}>
            <Modal.Header closeButton>
                <Modal.Title>Confirm</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {props.promptMessage}
            </Modal.Body>
            <Modal.Footer>
                <Toast
                    autohide={false}
                    delay={5000}
                    show={props.showError}
                    onClose={() => {
                        if(props.setShowError){
                            props.setShowError(false)
                        }
                    }}
                    style={{
                        color: 'red',
                        backgroundColor: '#f8f9fa00',
                        border: 'none',
                        boxShadow: 'none',
                        zIndex: 100,
                    }}
                >
                    <Toast.Body style={{padding: 0}}>Error occurred, please try again later</Toast.Body>
                </Toast>
                <Button style={{width: 80}} onClick={() => {
                    props.setShow(false);
                    if( props.setShowError){
                        props.setShowError(false);
                    }
                }} variant="primary">Cancel</Button>
                {props.isRequestInProgress ?
                    <Button style={{width: 80}}
                            variant="primary">OK
                        <Spinner
                            as="span"
                            animation="border"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                            className='ml-1'
                        />
                    </Button>
                    :
                    <Button style={{width: 80}} onClick={async () => await handleOk()} variant="primary">OK</Button>}
            </Modal.Footer>
        </Modal>
    )
}
